export default __webpack_public_path__ + "static/media/icon_close.69ead6ff.svg";